import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { ProductOptionChoiceModel } from './productOptionChoice';
import { getToolOptionTitleI18nKey } from 'src/_shared/utils/getI18nKeys';

export type TProductOptionModel = typeof ProductOptionModel;
export type ProductOptionModelInstance = Instance<TProductOptionModel>;
export interface IProductOptionModelIn extends SnapshotIn<TProductOptionModel> {}
export interface IProductOptionModelInstance extends ProductOptionModelInstance {}

export const ProductOptionModel = types
  .model({
    code: types.identifier,
    choices: types.optional(types.array(ProductOptionChoiceModel), []),
  })
  .views(self => ({
    get titleKey() {
      return getToolOptionTitleI18nKey(self.code);
    },
    get selectedChoice() {
      return self.choices.find(choice => choice.selected);
    },
  }))
  .actions(self => ({}));
